export default {
  forgot_password_confirm: {
    title: '重置密码',
    required_code: '验证码为必填项。',
    required_password: '密码为必填项。',
    max_length_16: '密码必须为8~16个字符。',
    // no_blank: "",
    no_password_match: '密码不一致。',
    reset_password: '重置密码',
    caution: '请勿关闭页面',
    double_check_text: '@:login.double_check_text',
    password_reset_text: '已向您输入的电子邮件地址发送邮件，请将邮件内的确认码输入至以下表格，并设置新密码。',
    verification_code: '确认码',
    mail_send_code: '发送至电子邮箱的验证码',
    password: '密码',
    new_password: '新密码',
    password_display: '显示密码',
    password_no_display: '未显示密码',
    password_check: '新密码（确认）',
    submit: '设置',
  },
}
